import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter2'
})
export class Filter2Pipe implements PipeTransform {

  transform(value: any[],filterString:string,propName:string,propName2:string): any[] {
    const Result=[]

    if(value.length ==0 || filterString=='' || propName==''){
      return value
    }

    for(const item in value){
      if(value[item][propName][propName2].toLowerCase().includes(filterString.toLowerCase()))
        Result.push(value[item])
    }

    return Result
  }

}
